import React from 'react'
import Gurden from './component/Gurden'

const App = () => {
  return (
    <Gurden/>
  )
}

export default App
